import { render } from "./HeaderDashboard.vue?vue&type=template&id=95c60bd2&scoped=true"
import script from "./HeaderDashboard.vue?vue&type=script&lang=js"
export * from "./HeaderDashboard.vue?vue&type=script&lang=js"

import "./HeaderDashboard.vue?vue&type=style&index=0&id=95c60bd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-95c60bd2"]])

export default __exports__